import { Paper, Typography, LinearProgress } from '@mui/material';
import { styled } from '@mui/material';

export const WidgetTitleContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 2%;
  line-height: 0;
  button {
    padding: 0%;
  }
`;
export const WidgetTitle = styled(Typography)`
  white-space: nowrap;
  line-height: 100%;
  color: ${({ theme }) => theme.palette.lightGrey.main};
`;

export const WidgetLoadingBar = styled(LinearProgress)`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
`;

export const WidgetContainer = styled(Paper, {shouldForwardProp : (prop) => 
  prop !== "$mobileRatio" &&
  prop !== "$maxheight" &&
  prop !== "$maxwidth" &&
  prop !== "$minheight" &&
  prop !== "$minwidth" &&
  prop !== "$ratio"
})<{
  $minheight?: number;
  $minwidth?: number;
  $maxwidth?: number;
  $maxheight?: number;
  $ratio?: string;
  $mobileRatio?: string;
}>`
  background-color: ${({ theme }) => theme.palette.background.paper};
  width: 100%;
  flex: 1;
  display: flex;
  transition: 0.2s;
  position: relative;
  border-radius: 12px;
  box-sizing: border-box;
  overflow: hidden;
  max-width: ${({ $maxwidth }) => `${$maxwidth}px`};
  max-height: ${({ $maxheight }) => `${$maxheight}px`};
  min-width: ${({ $minwidth }) => `${$minwidth}px`};
  min-height: ${({ $minheight }) => `${$minheight}px`};
  aspect-ratio: ${({ $ratio }) => `${$ratio}`};

  @media (max-width: ${({ theme }) => theme.breakpoints.values.sm}px) {
    aspect-ratio: ${({ $mobileRatio }) => `${$mobileRatio}`};
  }
  /* @media (min-width: ${({ theme }) => theme.breakpoints.values.xl}px) {
    max-width: ${({ $maxwidth }) => ($maxwidth ? `${$maxwidth * 2}px` : undefined)};
  } */
`;

export const WidgetIconContainer = styled('div')`
  width: 20%;
  min-width: 2.5rem;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.secondary.main};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.palette.primary.main};
  svg {
    color: ${({ theme }) => theme.palette.primary.main};
    width: 2rem;
    height: 2rem;
  }
`;
export const WidgetColumnContainer = styled('div')`
  display: flex;
  flex-direction: row;
  padding: 16px;
  width: 100%;
  gap: 16px;
`;
export const WidgetColumn = styled('div')`
  display: flex;
  flex-direction: column;
  flex-direction: column;
  justify-content: flex-start;
  gap: 2%;
  width: 100%;
`;
